'use client';

import { useState } from 'react';

export default function SupportPage() {
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Submit to API
        await fetch('/api/support', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ subject, message })
        });

        setSubmitted(true);
    };

    return (
        <div className="max-w-4xl mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-8">Support Center</h1>

            <div className="grid md:grid-cols-2 gap-8">
                {/* FAQ */}
                <div className="space-y-4">
                    <h2 className="text-xl font-semibold mb-4">Frequently Asked Questions</h2>

                    {[
                        { q: 'How do I track my order?', a: 'Go to Orders page and click on your order to see tracking.' },
                        { q: 'What is the return policy?', a: '30-day return policy on all items.' },
                        { q: 'How do I contact support?', a: 'Use the form or email support@vulnerashop.com' },
                    ].map((faq, i) => (
                        <div key={i} className="p-4 rounded-xl bg-slate-900/50 border border-slate-800">
                            <h3 className="font-medium mb-2">{faq.q}</h3>
                            <p className="text-slate-400 text-sm">{faq.a}</p>
                        </div>
                    ))}
                </div>

                {/* Contact Form */}
                <div className="p-6 rounded-2xl bg-slate-900/50 border border-slate-800">
                    <h2 className="text-xl font-semibold mb-6">Contact Us</h2>

                    {submitted ? (
                        <div className="text-center py-8">
                            <div className="text-5xl mb-4">✅</div>
                            <h3 className="text-xl font-semibold mb-2">Message Sent!</h3>
                            <p className="text-slate-400">We'll get back to you soon.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-slate-300 mb-2">Subject</label>
                                <input
                                    type="text"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                    className="w-full px-4 py-3 rounded-xl bg-slate-800 border border-slate-700 focus:border-indigo-500 outline-none"
                                    placeholder="What's this about?"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-slate-300 mb-2">Message</label>
                                <textarea
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    rows={5}
                                    className="w-full px-4 py-3 rounded-xl bg-slate-800 border border-slate-700 focus:border-indigo-500 outline-none resize-none"
                                    placeholder="Describe your issue..."
                                />
                            </div>

                            <button
                                type="submit"
                                className="w-full py-3 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 font-semibold hover:from-indigo-500 hover:to-purple-500 transition-all"
                            >
                                Send Message
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
